<template>
    <!-- 分页 -->
    <div class="page clearfix mt20">
        <div class="fl">
            <slot></slot>
        </div>
        <div class="fr">
            <Page
                :total="num"
                show-sizer
                @on-change="change_page"
                @on-page-size-change="change_opts"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: ['num'],
    data() {
        return {
            total: this.num,
        }
    },
    methods: {
        change_page(e) {
            this.$emit('changePage', e)
        },
        change_opts(e) {
            this.$emit('changeOpts', e)
        },
    },
}
</script>
<style scoped>
.page span {
    float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/page/page.vue